{
  "version": 1,
  "asset_id": "b1dc99c3-81b2-491b-a87f-1f015765738f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b1dc99c3-81b2-491b-a87f-1f015765738f/hiatal-normal-es-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b1dc99c3-81b2-491b-a87f-1f015765738f/hiatal-normal-es-v3-800.jpg",
  "original_filename": "hiatal-normal-es-v3-800.jpg",
  "size": 115550,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:12:01Z"
}
